import style from './StudentQuestionItem.scss';
import { IndicatorCell } from '../../../../components';
import { QUESTION_GROKKED } from '../../../../constants';
import { TickIcon } from '../Icons';
import PT from 'prop-types';

const getGrokkedDisplayValue = (grokked) => {
  switch (grokked) {
    case QUESTION_GROKKED.YES:
      return 'Understood';

    case QUESTION_GROKKED.NO:
      return 'Help needed';

    case QUESTION_GROKKED.NO_RESPONSE:
      return 'Not reflected';

    default:
      '';
  }
};

export const StudentQuestionItem = ({ answered, grokked }) => {
  const indicatorValue = getGrokkedDisplayValue(grokked);

  return (
    <>
      <div className={style.answeredContainer}>
        {answered ? (
          <div className={style.tickIconBackground}>
            <TickIcon />
          </div>
        ) : null}
      </div>
      <div className={style.indicatorCellContainer}>
        <IndicatorCell value={indicatorValue} indicatorType={grokked} />
      </div>
    </>
  );
};

StudentQuestionItem.propTypes = {
  answered: PT.bool.isRequired,
  grokked: PT.number,
};
